module.exports = __webpack_public_path__ + "img/crowdfunding.c5656bac.svg";